import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { Grid } from "@material-ui/core";

export default function PoliciesAndPremium(props) {
    const device = useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [dataPremium, setDataPremium] = React.useState([]);
    const [loadingPremium, setLoadingPremium] = React.useState(false);

    const GetData = async () => { 
        const response = await CallAPI("POST", "/Advanced/GetBoundPolicies", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                integer.format(row.totalPolicies),
                integer.format(row.online),
                integer.format(row.crc),
                integer.format(row.combo),
                integer.format(row.agency),
            ]);

            setData(formattedResponse);
        }

        setLoading(false);
    };

    const GetDataPremium = async () => {
        const response = await CallAPI("POST", "/Advanced/GetBoundPolicyPremium", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                currency.format(row.totalPremium.toFixed(0)),
                currency.format(row.overallAvgPrem.toFixed(0)),
                currency.format(row.onlineAvgPrem.toFixed(0)),
                currency.format(row.crcAvgPrem.toFixed(0)),
                currency.format(row.comboAvgPrem.toFixed(0)),
                currency.format(row.agencyAvgPrem.toFixed(0)),
            ]);

            setDataPremium(formattedResponse);
        } 

        setLoadingPremium(false);
    };
    
    useEffect(() => {
        if (props.call == "true" || props.call == null) {
            GetDataPremium();
            setLoadingPremium(true);
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="BOUND POLICIES"
                    exportName="Bound_Policies"
                    loading={loading}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { textAlign: "left", minWidth: "120px" },
                            Body: { textAlign: "left" },
                            Footer: { textAlign: "left" }
                        }
                    }}
                    headers={[[
                        props.groupBy, "Total Policies", "Online", "CRC",
                        {
                            text: (<>Combo<TooltipButton tooltipText={"Policies quoted online initially then bound by internal CURE reps only."} /></>),
                            style: { padding: "0" }
                        },
                        "Agency"
                    ]]}
                    rows={data.filter(x => x[0] !== "Total")}
                    footers={data.filter(x => x[0] === "Total")}
                />
            </Grid>
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="BOUND POLICY PREMIUM"
                    exportName="Bound_Policy_Premium"
                    loading={loadingPremium}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { textAlign: "left", minWidth: "120px" },
                            Body: { textAlign: "left" },
                            Footer: { textAlign: "left" }
                        }
                    }}
                    headers={[[
                        props.groupBy, "Total Premium", "Overall Avg Prem", "Online Avg Prem", "CRC Avg Prem", "Combo Avg Prem", "Agency Avg Prem"
                    ]]}
                    rows={dataPremium.filter(x => x[0] !== "Total")}
                    footers={dataPremium.filter(x => x[0] === "Total")}
                />
            </Grid>
        </Grid>
    );
}